import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import Search from "pages/search";
import SignIn from "pages/signIn";
import { Main } from "components/Layout";
import Home from "pages/Home";
import Tables from "pages/Tables";
import Billing from "pages/Billing";
import Profile from "pages/Profile";
import Tables2 from "pages/Tables2";
import AdminPage from "pages/admin";
import Landing from "pages/Landing";
import Apply from "pages/Apply";
import Leads from "pages/Leads";
import Bookings from "pages/Bookings";
import Invoices from "pages/Invoices";
import Reports from "pages/Reports";
import LeadInbox from "pages/LeadInbox";
import AccessDenied from "pages/AccessDenied";
import Applications from "pages/Applications";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  return isAuthenticated ? (typeof children === "function" ? children({ user }) : children) : <Navigate to="/sign-in" />;
};

const TenantRoute = ({ app, children }) => {
  const { user } = useAuth();
  const apps = user?.TenantApps || ["indigent", "lending", "leads"];
  if (app && !apps.includes(app)) {
    return <Navigate to="/access-denied" />;
  }
  return children;
};

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/" element={<Landing />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/access-denied" element={<AccessDenied />} />

        {/* Protected routes */}
        <Route
          path="/search"
          element={
            <ProtectedRoute>
              <TenantRoute app="indigent">
                <Search />
              </TenantRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Main />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<Home />} />
          <Route
            path="tables"
            element={
              <TenantRoute app="indigent">
                <Tables />
              </TenantRoute>
            }
          />
          <Route path="admin" element={<AdminPage />} />
          <Route path="billing" element={<Billing />} />
          <Route path="rtl" element={<Home />} />
          <Route path="profile" element={<Profile />} />
          <Route
            path="tables2"
            element={
              <TenantRoute app="indigent">
                <Tables2 />
              </TenantRoute>
            }
          />
          <Route
            path="leads"
            element={
              <TenantRoute app="leads">
                <Leads />
              </TenantRoute>
            }
          />
          <Route
            path="applications"
            element={
              <TenantRoute app="lending">
                <Applications />
              </TenantRoute>
            }
          />
          <Route
            path="lead-inbox"
            element={
              <TenantRoute app="leads">
                <LeadInbox />
              </TenantRoute>
            }
          />
          <Route
            path="bookings"
            element={
              <TenantRoute app="leads">
                <Bookings />
              </TenantRoute>
            }
          />
          <Route
            path="invoices"
            element={
              <TenantRoute app="leads">
                <Invoices />
              </TenantRoute>
            }
          />
          <Route
            path="reports"
            element={
              <TenantRoute app="leads">
                <Reports />
              </TenantRoute>
            }
          />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
